const players = [
    {
        name: "Aaron Rai",
        img: "./img/players/aaron_rai.png"
    },
    {
        name: "Adam Scott",
        img: "./img/players/adam_scott.png"
    },
    {
        name: "Adrien Saddier",
        img: "./img/players/adrien_saddier.png"
    },
    {
        name: "Akshay Bhatia",
        img: "./img/players/akshay_bhatia.png"
    },
    {
        name: "Alejandro De Castro Piera",
        img: "./img/players/alejandro_de_castro_piera.png"
    },
    {
        name: "Alex Fitzpatrick",
        img: "./img/players/alex_fitzpatrick.png"
    },
    {
        name: "Alex Noren",
        img: "./img/players/alex_noren.png"
    },
    {
        name: "Alex Smalley",
        img: "./img/players/alex_smalley.png"
    },
    {
        name: "Alistair Docherty",
        img: "./img/players/alistair_docherty.png"
    },
    {
        name: "Andrew Novak",
        img: "./img/players/andrew_novak.png"
    },
    {
        name: "Angel Ayora",
        img: "./img/players/angel_ayora.png"
    },
    {
        name: "Antoine Rozner",
        img: "./img/players/antoine_rozner.png"
    },
    {
        name: "Austen Truslow",
        img: "./img/players/austen_truslow.png"
    },
    {
        name: "Baard Bjoernevik Skogen",
        img: "./img/players/baard_bjoernevik_skogen.png"
    },
    {
        name: "Ben Griffin",
        img: "./img/players/ben_griffin.png"
    },
    {
        name: "Billy Horschel",
        img: "./img/players/billy_horschel.png"
    },
    {
        name: "Brian Harman",
        img: "./img/players/brian_harman.png"
    },
    {
        name: "Brooks Koepka",
        img: "./img/players/brooks_koepka.png"
    },
    {
        name: "Bryson DeChambeau",
        img: "./img/players/bryson_dechambeau.png"
    },
    {
        name: "Bud Cauley",
        img: "./img/players/bud_cauley.png"
    },
    {
        name: "Caleb Surratt",
        img: "./img/players/caleb_surratt.png"
    },
    {
        name: "Cameron John",
        img: "./img/players/cameron_john.png"
    },
    {
        name: "Cameron Smith",
        img: "./img/players/cameron_smith.png"
    },
    {
        name: "Cameron Young",
        img: "./img/players/cameron_young.png"
    },
    {
        name: "Casey Jarvis",
        img: "./img/players/casey_jarvis.png"
    },
    {
        name: "Chris Gotterup",
        img: "./img/players/chris_gotterup.png"
    },
    {
        name: "Collin Morikawa",
        img: "./img/players/collin_morikawa.png"
    },
    {
        name: "Corey Conners",
        img: "./img/players/corey_conners.png"
    },
    {
        name: "Daniel Berger",
        img: "./img/players/daniel_berger.png"
    },
    {
        name: "Daniel Brown",
        img: "./img/players/daniel_brown.png"
    },
    {
        name: "Daniel Hillier",
        img: "./img/players/daniel_hillier.png"
    },
    {
        name: "Darren Clarke",
        img: "./img/players/darren_clarke.png"
    },
    {
        name: "David Duval",
        img: "./img/players/david_duval.png"
    },
    {
        name: "David Howard",
        img: "./img/players/david_howard.png"
    },
    {
        name: "Eugenio Chacarra",
        img: "./img/players/eugenio_chacarra.png"
    },
    {
        name: "Fifa Laopakdee",
        img: "./img/players/fifa_laopakdee.png"
    },
    {
        name: "Francesco Laporta",
        img: "./img/players/francesco_laporta.png"
    },
    {
        name: "Francesco Molinari",
        img: "./img/players/francesco_molinari.png"
    },
    {
        name: "Frederic Lacroix",
        img: "./img/players/frederic_lacroix.png"
    },
    {
        name: "Gary Woodland",
        img: "./img/players/gary_woodland.png"
    },
    {
        name: "Haotong Li",
        img: "./img/players/haotong_li.png"
    },
    {
        name: "Harris English",
        img: "./img/players/harris_english.png"
    },
    {
        name: "Harry Hall",
        img: "./img/players/harry_hall.png"
    },
    {
        name: "Henrik Stenson",
        img: "./img/players/henrik_stenson.png"
    },
    {
        name: "Hideki Matsuyama",
        img: "./img/players/hideki_matsuyama.png"
    },
    {
        name: "Jack Buchanan",
        img: "./img/players/jack_buchanan.png"
    },
    {
        name: "Jack McDonald",
        img: "./img/players/jack_mcdonald.png"
    },
    {
        name: "Jackson Suber",
        img: "./img/players/jackson_suber.png"
    },
    {
        name: "Jacob Bridgeman",
        img: "./img/players/jacob_bridgeman.png"
    },
    {
        name: "Jake Knapp",
        img: "./img/players/jake_knapp.png"
    },
    {
        name: "James Nicholas",
        img: "./img/players/james_nicholas.png"
    },
    {
        name: "Jason Day",
        img: "./img/players/jason_day.png"
    },
    {
        name: "Jeongwoo Ham",
        img: "./img/players/jeongwoo_ham.png"
    },
    {
        name: "Jesper Svensson",
        img: "./img/players/jesper_svensson.png"
    },
    {
        name: "Jiho Yang",
        img: "./img/players/jiho_yang.png"
    },
    {
        name: "JJ Spaun",
        img: "./img/players/jj_spaun.png"
    },
    {
        name: "Joakim Lagergren",
        img: "./img/players/joakim_lagergren.png"
    },
    {
        name: "Joaquin Niemann",
        img: "./img/players/joaquin_niemann.png"
    },
    {
        name: "John Parry",
        img: "./img/players/john_parry.png"
    },
    {
        name: "Jon Rahm",
        img: "./img/players/jon_rahm.png"
    },
    {
        name: "Jordan Smith",
        img: "./img/players/jordan_smith.png"
    },
    {
        name: "Jordan Spieth",
        img: "./img/players/jordan_spieth.png"
    },
    {
        name: "Jose Luis Ballester Barrio",
        img: "./img/players/jose_luis_ballester_barrio.png"
    },
    {
        name: "JT Poston",
        img: "./img/players/jt_poston.png"
    },
    {
        name: "Justin Rose",
        img: "./img/players/justin_rose.png"
    },
    {
        name: "Justin Thomas",
        img: "./img/players/justin_thomas.png"
    },
    {
        name: "Kazuki Higa",
        img: "./img/players/kazuki_higa.png"
    },
    {
        name: "Kazuma Kobori",
        img: "./img/players/kazuma_kobori.png"
    },
    {
        name: "Keegan Bradley",
        img: "./img/players/keegan_bradley.png"
    },
    {
        name: "Keita Nakajima",
        img: "./img/players/keita_nakajima.png"
    },
    {
        name: "Kota Kaneko",
        img: "./img/players/kota_kaneko.png"
    },
    {
        name: "Kristoffer Reitan",
        img: "./img/players/kristoffer_reitan.png"
    },
    {
        name: "Kurt Kitayama",
        img: "./img/players/kurt_kitayama.png"
    },
    {
        name: "Laurie Canter",
        img: "./img/players/laurie_canter.png"
    },
    {
        name: "Lev Grinberg",
        img: "./img/players/lev_grinberg.png"
    },
    {
        name: "Louis Oosthuizen",
        img: "./img/players/louis_oosthuizen.png"
    },
    {
        name: "Lucas Herbert",
        img: "./img/players/lucas_herbert.png"
    },
    {
        name: "Ludvig Aberg",
        img: "./img/players/ludvig_aberg.png"
    },
    {
        name: "Marco Penge",
        img: "./img/players/marco_penge.png"
    },
    {
        name: "Marcus Plunkett",
        img: "./img/players/marcus_plunkett.png"
    },
    {
        name: "Martin Couvra",
        img: "./img/players/martin_couvra.png"
    },
    {
        name: "Mason Howell",
        img: "./img/players/mason_howell.png"
    },
    {
        name: "Mateo Pulcini",
        img: "./img/players/mateo_pulcini.png"
    },
    {
        name: "Matt Fitzpatrick",
        img: "./img/players/matt_fitzpatrick.png"
    },
    {
        name: "Matt McCarty",
        img: "./img/players/matt_mccarty.png"
    },
    {
        name: "Matthew Baldwin",
        img: "./img/players/matthew_baldwin.png"
    },
    {
        name: "Matthew Jordan",
        img: "./img/players/matthew_jordan.png"
    },
    {
        name: "Matthew Southgate",
        img: "./img/players/matthew_southgate.png"
    },
    {
        name: "Maverick McNealy",
        img: "./img/players/maverick_mcnealy.png"
    },
    {
        name: "Michael Hollick",
        img: "./img/players/michael_hollick.png"
    },
    {
        name: "Michael Kim",
        img: "./img/players/michael_kim.png"
    },
    {
        name: "Min Woo Lee",
        img: "./img/players/min_woo_lee.png"
    },
    {
        name: "MJ Daffue",
        img: "./img/players/mj_daffue.png"
    },
    {
        name: "Naoyuki Kataoka",
        img: "./img/players/naoyuki_kataoka.png"
    },
    {
        name: "Nevill Ruiter",
        img: "./img/players/nevill_ruiter.png"
    },
    {
        name: "Nick Taylor",
        img: "./img/players/nick_taylor.png"
    },
    {
        name: "Nicolai Hojgaard",
        img: "./img/players/nicolai_hojgaard.png"
    },
    {
        name: "Padraig Harrington",
        img: "./img/players/padraig_harrington.png"
    },
    {
        name: "Patrick Cantlay",
        img: "./img/players/patrick_cantlay.png"
    },
    {
        name: "Patrick Reed",
        img: "./img/players/patrick_reed.png"
    },
    {
        name: "Peter Uihlein",
        img: "./img/players/peter_uihlein.png"
    },
    {
        name: "Rasmus Hojgaard",
        img: "./img/players/rasmus_hojgaard.png"
    },
    {
        name: "Rasmus Neergaard-Petersen",
        img: "./img/players/rasmus_neergaard-petersen.png"
    },
    {
        name: "Ren Yonezawa",
        img: "./img/players/ren_yonezawa.png"
    },
    {
        name: "Rickie Fowler",
        img: "./img/players/rickie_fowler.png"
    },
    {
        name: "Robert MacIntyre",
        img: "./img/players/robert_macintyre.png"
    },
    {
        name: "Rory McIlroy",
        img: "./img/players/rory_mcilroy.png"
    },
    {
        name: "Russell Henley",
        img: "./img/players/russell_henley.png"
    },
    {
        name: "Ryan Fox",
        img: "./img/players/ryan_fox.png"
    },
    {
        name: "Ryan Gerard",
        img: "./img/players/ryan_gerard.png"
    },
    {
        name: "Ryutaro Nagano",
        img: "./img/players/ryutaro_nagano.png"
    },
    {
        name: "Sam Bairstow",
        img: "./img/players/sam_bairstow.png"
    },
    {
        name: "Sam Burns",
        img: "./img/players/sam_burns.png"
    },
    {
        name: "Scott Vincent",
        img: "./img/players/scott_vincent.png"
    },
    {
        name: "Scottie Scheffler",
        img: "./img/players/scottie_scheffler.png"
    },
    {
        name: "Sepp Straka",
        img: "./img/players/sepp_straka.png"
    },
    {
        name: "Shane Lowry",
        img: "./img/players/shane_lowry.png"
    },
    {
        name: "Shaun Norris",
        img: "./img/players/shaun_norris.png"
    },
    {
        name: "Si Woo Kim",
        img: "./img/players/si_woo_kim.png"
    },
    {
        name: "Stewart Cink",
        img: "./img/players/stewart_cink.png"
    },
    {
        name: "Stuart Grehan",
        img: "./img/players/stuart_grehan.png"
    },
    {
        name: "Sungjae Im",
        img: "./img/players/sungjae_im.png"
    },
    {
        name: "Tiger Christensen",
        img: "./img/players/tiger_christensen.png"
    },
    {
        name: "Tim Wiedemeyer",
        img: "./img/players/tim_wiedemeyer.png"
    },
    {
        name: "Tom McKibbin",
        img: "./img/players/tom_mckibbin.png"
    },
    {
        name: "Tom Sloman",
        img: "./img/players/tom_sloman.png"
    },
    {
        name: "Tommy Fleetwood",
        img: "./img/players/tommy_fleetwood.png"
    },
    {
        name: "Travis Smyth",
        img: "./img/players/travis_smyth.png"
    },
    {
        name: "Tyrrell Hatton",
        img: "./img/players/tyrrell_hatton.png"
    },
    {
        name: "Viktor Hovland",
        img: "./img/players/viktor_hovland.png"
    },
    {
        name: "Wyndham Clark",
        img: "./img/players/wyndham_clark.png"
    },
    {
        name: "Xander Schauffele",
        img: "./img/players/xander_schauffele.png"
    }
]

export default players
